var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,8.5859375L5.7070312,6.2929688L4.2929688,7.7070312l3,3C7.4882812,10.9023438,7.7441406,11,8,11 s0.5117188-0.0976562,0.7070312-0.2929688l8-8l-1.4140625-1.4140625L8,8.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,44.5859375l-2.2929688-2.2929688l-1.4140625,1.4140625l3,3C7.4882812,46.9023438,7.7441406,47,8,47 s0.5117188-0.0976562,0.7070312-0.2929688l8-8l-1.4140625-1.4140625L8,44.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,20.5859375l-2.2929688-2.2929688l-1.4140625,1.4140625l3,3C7.4882812,22.9023438,7.7441406,23,8,23 s0.5117188-0.0976562,0.7070312-0.2929688l8-8l-1.4140625-1.4140625L8,20.5859375z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,32.5859375l-2.2929688-2.2929688l-1.4140625,1.4140625l3,3C7.4882812,34.9023438,7.7441406,35,8,35 s0.5117188-0.0976562,0.7070312-0.2929688l8-8l-1.4140625-1.4140625L8,32.5859375z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 42,
    width: 24,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesMedium);
export default __webpack_public_path__ + "static/media/features--medium.00ba2fcb7244468c0f3d621f129e3556.svg";
export { ForwardRef as ReactComponent };